var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 6,
    y: 7,
    width: 8,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 6,
    y: 10.499,
    width: 5,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0a3 3 0 013 3v11a6 6 0 01-6 6H4a3 3 0 01-3-3V6a6 6 0 016-6h9zm0 1.5H7a4.5 4.5 0 00-4.495 4.288L2.5 6v11a1.5 1.5 0 001.356 1.493L4 18.5h9a4.5 4.5 0 004.495-4.288L17.5 14V3a1.5 1.5 0 00-1.356-1.493L16 1.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
export default SvgArchive;